<!-- TODO Ionic removal: think about using a card component here instead of ui-section -->
@if (realtimeAnalysisStateLikeData()) {
    <ui-section class="width-100">
        <ui-section-content>
            <div class="title-row">
                <edit-text
                    [disabled]="!(tileConfig.hasTileAdminAccess$ | async)"
                    [(ngModel)]="tileData.name"
                    (ngModelChange)="updateTileName()"
                />
                <div class="action-buttons">
                    @if (tileConfig.hasTileAdminAccess$ | async) {
                        <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
                    }
                </div>
            </div>
            @if (mapRealtimeAnalysisData(); as config) {
                <sen-analysis-main-chart [chartConfig]="config" [onlyGraph]="true" />
            } @else {
                <div class="items-center gap-2">
                    <ui-spinner class="m-4" />
                </div>
            }
        </ui-section-content>
    </ui-section>
}
